import { React, useState, useEffect } from 'react'
// import { HashLink as Link } from 'react-router-hash-link';
import { motion, useAnimation } from "framer-motion";
import { useParams, } from "react-router-dom";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faClock, faLocationDot, faEnvelope, faPhone, faGlobe, faBuilding, faList, faScaleBalanced, faCalendarPlus, faChampagneGlasses, faUsers } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'
import CTAButton from '../../../components/CTAButton/CTAButton.js'
import ScheduleDutyCard from '../../../components/ScheduleDutyCard/ScheduleDutyCard.js'

import { lP, oP, sT, boxvar1, boxvar2, boxvar3, boxvar2_1, boxvar2_2, boxvar2_3, boxvar4, URL_MAINAPI, API_TOKEN, formatDateWithTime, formatScheduleDayWithWeekday } from '../../../main.js'

import '../../../main.css'
import './EventRegisterSchedule.css'
import './MEventRegisterSchedule.css'

import img_not_found from '../../../assets/pictures/imgnotfound.webp'


import Cookies from 'universal-cookie'

export default function EventRegisterSchedule() {

    const cookies = new Cookies()
    let cur_userid = cookies.get('userid')
    let cur_firstname = cookies.get('firstname')
    let cur_lastname = cookies.get('lastname')
    let cur_authtoken = cookies.get('authtoken')
    let loggedin = (cur_userid != "" && cur_userid != undefined)

    const { eventid } = useParams();
    var [eventFound, setEventFound] = useState(1)
    var [resError, setResError] = useState("")

    var [eventRegistered, setEventRegistered] = useState(0)
    var [eventScheduleRegistered, setEventScheduleRegistered] = useState(0)

    var [formError, setFormError] = useState(false)

    var [scheduleFormData, setScheduleFormData] = useState({ a: 0 })
    var [scheduleRemark, setScheduleRemark] = useState("")
    var [companions, setCompanions] = useState([])

    var [eventData, setEventData] = useState({
        eventId: "",
        eventOrgId: "",
        eventName: "",
        eventLongName: "Event wird geladen...",
        eventLogo: img_not_found,
        eventHeroImg: img_not_found,
        eventURL: "#",
        eventImprintURL: "#",
        eventOrganizator: "unbekannt",
        eventContactURL: "#",
        eventContactMail: "",
        eventContactTel: "",
        eventSlogan: "Mach mit!",
        eventApplicationActive: false,
        eventWaitlistEnabled: true,
        eventGroupRegistrationEnabled: false,
        eventMaxGroupPersons: 5,
        eventRemarksEnabled: true,
        eventDates: {
            dateStart: "",
            dateEnd: "",
            applicationEnd: "",
            applicationStart: "",
        },
        eventStyle: {
            colorPrimary: '#662773',
            colorPrimaryGradient: '#986da0',
            colorSecondary: '#94b654',
            colorTileBg: '#f6deff',
            colorStdText: '#000000',
            colorBtnText: '#ffffff',
            colorStdTextOnTile: '#000000'
        },
        eventInfo: {
            box1Header: "Was ist das",
            box1Text: "Eventbeschreibung wird geladen...",
            box1HeroImg: null,
            box2Header: "Deine Aufgaben",
            box2Text1: "Aufgabenbeschreibung wird geladen...",
            box2Text2: "",
            box2CtaText: "Registrieren",
            box3Header: "Eckdaten",
            box3Contents: "",
            box3LookingFor: "",
            box3Text: "Weitere Fragen an den Veranstalter?",
            box3CtaText: "Kontakt"
        }
    })

    var [eventScheduleData, setEventScheduleData] = useState({
        eventId: "0",
        dates: [
            {
                day: "01.01.1900",
                schedules: [
                    {
                        scheduleElementId: "0",
                        title: "Beispiel",
                        startTime: "00:00",
                        endTime: "23:59",
                        description: "Beispielzeitraum",
                        location: "",
                        dutys: [
                            {
                                dutyId: "0",
                                title: "Beispieldienst",
                                description: "Dies ist ein Beispiel",
                                maxPersons: 0,
                                currentPersons: 0,
                                isFull: 0,
                            },
                        ]
                    },
                ]
            },
        ]
    });


    useEffect(() => {

        window.onbeforeunload = function () {
            return "Willst du wirklich abbrechen? Du musst vorher absenden";
        };

        // setCur_userid(cookies.get('userid'))

        if (eventid == "0" || eventid == null) { } else {
            getEventData()
            getEventRegistered()
            getEventScheduleData()
        }

        const listener = event => {

            if (event.code === "Enter" || event.code === "NumpadEnter") {
                // setFormUsername(document.querySelector('.in_username').value)
                // setFormPassword(document.querySelector('.in_password').value)
                // doLogin()
                // event.preventDefault()
            }
        }
        document.addEventListener("keydown", listener)
        return () => {
            document.removeEventListener("keydown", listener)
        }


    }, [])

    function getEventData() {

        try {
            fetch(URL_MAINAPI + "/event/" + eventid, {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {
                    setEventFound(1)
                    applyEventData(res.data);

                    // lP('/eventmailverification/' + eventid + '?formVorname=' + formData.formVorname + '&formNachname=' + formData.formNachname);

                } else {
                    setEventFound(0)
                }
            })
            )

        } catch (err) {
            setEventFound(0)
        }

    }

    function applyEventData(metadata) {


        setEventData({
            eventId: metadata._id,
            eventOrgId: (metadata.organization && metadata.organization._id) ? String(metadata.organization._id) : (metadata.orgid ? String(metadata.orgid) : ""),
            eventName: metadata.name,
            eventLongName: metadata.longname,
            eventLogo: metadata.logo_img,
            eventHeroImg: metadata.hero_img,
            eventURL: metadata.url,
            eventOrganizator: metadata.organization.name,
            eventContactURL: metadata.organization.contact.url,
            eventImprintURL: metadata.organization.contact.imprint_url,
            eventContactMail: metadata.organization.contact.email,
            eventContactTel: metadata.organization.contact.tel,
            eventSlogan: metadata.slogan,
            eventWaitlistEnabled: metadata.waitlistEnabled,
            eventGroupRegistrationEnabled: metadata.groupRegistrationEnabled == 1,
            eventMaxGroupPersons: Math.min(30, Math.max(1, Number(metadata.maxGroupPersons) || 5)),
            eventRemarksEnabled: metadata.remarksEnabled != 0,
            eventApplicationActive: metadata.applicationActive,
            eventDates: {
                dateStart: metadata.dates.dateStart,
                dateEnd: metadata.dates.dateEnd,
                applicationStart: metadata.dates.applicationStart,
                applicationEnd: metadata.dates.applicationEnd
            },
            eventCustomStyle: metadata.customstyle,
            eventStyle: {
                colorPrimary: metadata.style.colorPrimary,
                colorPrimaryGradient: metadata.style.colorPrimaryGradient,
                colorSecondary: metadata.style.colorSecondary,
                colorTileBg: metadata.style.colorTileBg,
                colorStdText: metadata.style.colorStdText,
                colorBtnText: metadata.style.colorBtnText,
                colorStdTextOnTile: metadata.style.colorStdTextOnTile
            },
            eventInfo: {
                box1Header: metadata.info.box1Header,
                box1Text: metadata.info.box1Text,
                box1HeroImg: metadata.info.box1HeroImg,
                box2Header: metadata.info.box2Header,
                box2Text1: metadata.info.box2Text1,
                box2Text2: metadata.info.box2Text2,
                box2CtaText: metadata.info.box2CtaText,
                box3Header: metadata.info.box3Header,
                box3Contents: metadata.info.box3Contents,
                box3LookingFor: metadata.info.box3LookingFor,
                box3Text: metadata.info.box3Text,
                box3CtaText: metadata.info.box3CtaText
            }
        });

        if (metadata.customstyle) {
            document.documentElement.style.setProperty('--event_color_primary', metadata.style.colorPrimary);
            document.documentElement.style.setProperty('--event_color_primarygradient', metadata.style.colorPrimaryGradient);
            document.documentElement.style.setProperty('--event_color_secondary', metadata.style.colorSecondary);
            document.documentElement.style.setProperty('--event_color_tilebg', metadata.style.colorTileBg);
            document.documentElement.style.setProperty('--event_color_stdtext', metadata.style.colorStdText);
            document.documentElement.style.setProperty('--event_color_stdtextontile', metadata.style.colorStdTextOnTile);
            document.documentElement.style.setProperty('--event_color_btntext', metadata.style.colorBtnText);
        }

    }

    function getEventRegistered() {

        try {

            fetch(URL_MAINAPI + "/user/attend/" + eventid, {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {

                    setEventRegistered(res.data.eventregistered ? 1 : 0)
                    setEventScheduleRegistered(res.data.eventscheduleregistered ? 1 : 0)

                    if (res.data.eventregistered != 1) {
                        window.location.href = "/event/" + eventid;
                    }

                } else {
                    setEventRegistered(0)
                    setEventScheduleRegistered(0)
                }
            })
            )

        } catch (err) {
            setEventRegistered(0)
            setEventScheduleRegistered(0)
        }

    }

    function getEventScheduleData() {
        try {
            fetch(URL_MAINAPI + "/eventschedule/" + eventid, {
                method: "GET",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN
                },
                // body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // console.log(res.data)

                if (res.status == 200) {
                    setEventFound(1)
                    applyEventSchedulaData(res.data);

                    // lP('/eventmailverification/' + eventid + '?formVorname=' + formData.formVorname + '&formNachname=' + formData.formNachname);

                } else {
                    setEventFound(0)
                }
            })
            )

        } catch (err) {
            setEventFound(0)
        }

    }

    function applyEventSchedulaData(scheduledata) {
        // console.log(scheduledata.dates[0].day);
        setEventScheduleData({
            eventId: scheduledata.eventid,
            dates: scheduledata.dates
                .sort((a, b) => new Date(a.day.split('.').reverse().join('-')) - new Date(b.day.split('.').reverse().join('-'))) // Sortieren nach "YYYY-MM-DD" Format; Aufsteigend
                .map(date => ({
                    day: date.day,
                    schedules: date.schedules.map(schedule => ({
                        scheduleElementId: schedule._id,
                        title: schedule.title,
                        startTime: schedule.startTime,
                        endTime: schedule.endTime,
                        description: schedule.description,
                        location: schedule.location,
                        dutys: schedule.dutys.map(duty => ({
                            dutyId: duty._id,
                            title: duty.title,
                            description: duty.description,
                            maxPersons: duty.maxPersons,
                            currentPersons: duty.currentPersons,
                            isFull: duty.isFull
                            //DONE check for in backend
                            // currentPersons: 0,
                            // isFull: 0,
                        }))
                    }))
                }))
        });

    }

    function addCompanion() {
        const maxCompanions = eventData.eventMaxGroupPersons || 5
        if (!eventData.eventGroupRegistrationEnabled || companions.length >= maxCompanions) return
        setCompanions([...companions, { firstname: "", lastname: "" }])
    }

    function removeCompanion(index) {
        setCompanions(companions.filter((_, i) => i !== index))
    }

    function updateCompanion(index, field, value) {
        setCompanions(companions.map((c, i) => i === index ? { ...c, [field]: value } : c))
    }

    function validateCompanions() {
        if (!eventData.eventGroupRegistrationEnabled) return ""
        const maxCompanions = eventData.eventMaxGroupPersons || 5
        if (companions.length > maxCompanions) return "Maximal " + maxCompanions + " weitere Personen möglich."
        for (let i = 0; i < companions.length; i++) {
            const firstname = (companions[i].firstname || "").trim()
            const lastname = (companions[i].lastname || "").trim()
            if (!firstname || !lastname) {
                return "Bitte Vor- und Nachname für alle Mitbringer ausfüllen (Person " + (i + 1) + ")."
            }
        }
        return ""
    }

    function postDutySelection() {

        const companionError = validateCompanions()
        if (companionError) {
            document.querySelector("#responseInfo_loading").style.display = "none"
            document.querySelector("#responseInfo_wronginput").style.display = "block"
            document.querySelector("#responseInfo_already").style.display = "none"
            setResError(companionError)
            setFormError(true)
            return
        }

        var dutyselectionRaw = scheduleFormData;
        delete dutyselectionRaw["a"];
        var dutyselectionMapped = Object.entries(dutyselectionRaw).map(([dutyid, selection]) => ({
            dutyid,
            selection
        }));

        console.log(dutyselectionMapped);

        const companionsPayload = eventData.eventGroupRegistrationEnabled
            ? companions.map(c => ({
                firstname: (c.firstname || "").trim(),
                lastname: (c.lastname || "").trim(),
            }))
            : []

        let reqbody = {
            dutys: dutyselectionMapped,
            eventid: eventid,
            remark: eventData.eventRemarksEnabled ? (scheduleRemark || "").trim().slice(0, 200) : "",
            companions: companionsPayload,
        }
        console.log(reqbody);


        document.querySelector("#responseInfo_loading").style.display = "block"
        document.querySelector("#responseInfo_wronginput").style.display = "none"
        document.querySelector("#responseInfo_already").style.display = "none"

        try {

            fetch(URL_MAINAPI + "/eventscheduleregister/submit", {
                method: "POST",
                // mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
                body: JSON.stringify(reqbody),

            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                // sT('#scheduleregistersubmitbtn')
                if (res.status == 200) {
                    setResError("");
                    document.querySelector("#responseInfo_loading").style.display = "none"
                    window.onbeforeunload = function () {
                        return null;
                    };
                    if (res.data.adjustedDutys && res.data.adjustedDutys.length > 0) {
                        try {
                            sessionStorage.setItem(
                                'scheduleAdjustments_' + eventid,
                                JSON.stringify(res.data.adjustedDutys)
                            )
                        } catch (e) { }
                    } else {
                        try { sessionStorage.removeItem('scheduleAdjustments_' + eventid) } catch (e) { }
                    }
                    lP("/eventregisterthanks/" + eventid);
                } else if (res.status == 406) {
                    console.log(res.data)
                    document.querySelector("#responseInfo_loading").style.display = "none"
                    document.querySelector("#responseInfo_already").style.display = "block"
                    setResError(res.data.error);
                } else {
                    console.log(res.data)
                    document.querySelector("#responseInfo_loading").style.display = "none"
                    document.querySelector("#responseInfo_wronginput").style.display = "block"
                    setResError(res.data.error);
                }
            })
            )
        } catch (err) {
            console.log(err)
            document.querySelector("#responseInfo_loading").style.display = "none"
            document.querySelector("#responseInfo_servererror").style.display = "block"
            setResError(err);
        }
    }

    if (eventid == "0" || eventid == null || eventFound == 0) {

        return (
            <div className={'mainCon page' + (eventData.eventCustomStyle ? ' event-styled' : '')} id='mainCon_registerschedule'>
                <MainHeader selectedsite={""} />
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Eventzeitplan</title>
                    <meta name="robots" content="noindex" />

                </Helmet>

                <main className='page-body'>
                    <div className='container'>
                        <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                            <div className='card error-card'>
                                <h3>Das gesuchte Event wurde nicht gefunden!</h3>
                                <p>Bitte kehre zur vorigen Seite zurück. Oder versuche den Veranstalter zu kontaktieren.</p><br />
                                <CTAButton variant="primary" hideArrow={true} title={"Startseite"} onclick={() => lP('/')}></CTAButton>
                            </div>
                        </motion.div>
                    </div>
                </main>

                < MainFooter useEventStyle={true} />
            </div >
        );
    }


    return (
        <div className={'mainCon page' + (eventData.eventCustomStyle ? ' event-styled' : '')} id='mainCon_registerschedule'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Eventzeitplan: {eventData.eventName}</title>
                <meta property="og:title" content={"Zeitplan für Helferzeit-Event: " + eventData.eventName} />
                <meta property="og:description" content={"Melde dich hier für die Dienste der Veranstaltung an: " + eventData.eventLongName + ""} />
                <meta name="robots" content="noindex" />

            </Helmet>

            <div className='eventbar'>
                <div className='eventbar-inner'>
                    <motion.img variants={boxvar4} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} alt='Logo des Veranstalters bzw. der Organisation' className='eventbar-logo' src={eventData.eventLogo} onClick={() => oP(eventData.eventURL)}></motion.img>
                    <motion.h2 variants={boxvar4} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }} className='eventbar-name' onClick={() => lP('/event/' + eventid)} style={{ cursor: "pointer" }}>{eventData.eventName == "" ? <Skeleton height={22} width="60%" /> : eventData.eventLongName}</motion.h2>
                </div>
            </div>

            <main className='page-body'>
                <section className='container section' style={{ paddingTop: '40px' }}>

                    <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>
                        <div className='card schedule-card'>
                            <div className='schedule_cont'>
                                <h2>Wähle hier deine Wunschdienste aus</h2>

                                {eventData.eventRemarksEnabled ? (
                                    <div className='schedule_remark_cont'>
                                        <label htmlFor='schedule_remark' className='schedule_remark_label'>Bemerkung (optional)</label>
                                        <textarea
                                            id='schedule_remark'
                                            className='schedule_remark_input'
                                            placeholder='z.B. Kann keine schweren Sachen heben'
                                            maxLength={200}
                                            rows={3}
                                            value={scheduleRemark}
                                            onChange={(e) => setScheduleRemark(e.target.value)}
                                        />
                                        <span className='schedule_remark_counter'>{scheduleRemark.length}/200</span>
                                    </div>
                                ) : null}

                                {eventData.eventGroupRegistrationEnabled ? (
                                    <div className='schedule_companions_cont'>
                                        <label className='schedule_remark_label'>Weitere Personen mitbringen</label>
                                        <p className='schedule_companions_hint'>
                                            Mitbringer erhalten dieselben Wunschdienste wie du und brauchen keinen eigenen Account.
                                        </p>
                                        <div className='schedule_companions_stepper'>
                                            <button
                                                type='button'
                                                className='schedule_companions_stepper_btn'
                                                onClick={addCompanion}
                                                disabled={companions.length >= (eventData.eventMaxGroupPersons || 5)}
                                                aria-label='Mitbringer hinzufügen'
                                            >+</button>
                                            <span className='schedule_companions_stepper_label'>
                                                {companions.length === 0 ? 'Person hinzufügen' : companions.length === 1 ? '1 Person zusätzlich' : companions.length + ' Personen zusätzlich'}
                                                {companions.length >= (eventData.eventMaxGroupPersons || 5) ? ' (max. ' + (eventData.eventMaxGroupPersons || 5) + ')' : ''}
                                            </span>
                                        </div>
                                        {companions.map(function (companion, index) {
                                            return (
                                                <div className='schedule_companion_row' key={'companion_' + index}>
                                                    <span className='schedule_companion_index'>+{index + 1}</span>
                                                    <input
                                                        type='text'
                                                        className='schedule_companion_input'
                                                        placeholder='Vorname'
                                                        maxLength={50}
                                                        value={companion.firstname}
                                                        onChange={(e) => updateCompanion(index, 'firstname', e.target.value)}
                                                        aria-label={'Vorname Mitbringer ' + (index + 1)}
                                                    />
                                                    <input
                                                        type='text'
                                                        className='schedule_companion_input'
                                                        placeholder='Nachname'
                                                        maxLength={50}
                                                        value={companion.lastname}
                                                        onChange={(e) => updateCompanion(index, 'lastname', e.target.value)}
                                                        aria-label={'Nachname Mitbringer ' + (index + 1)}
                                                    />
                                                    <button
                                                        type='button'
                                                        className='schedule_companion_remove_btn'
                                                        onClick={() => removeCompanion(index)}
                                                        aria-label={'Mitbringer ' + (index + 1) + ' entfernen'}
                                                    >Entfernen</button>
                                                </div>
                                            )
                                        })}
                                    </div>
                                ) : null}

                                <div className='schedule_dates_list'>
                                    {eventScheduleData.dates.map(function (scheduledates) {
                                        console.log(scheduledates.schedules);

                                        return (

                                            <div className='schedule_date'>
                                                <h3><FontAwesomeIcon icon={faCalendarDays} /> {formatScheduleDayWithWeekday(scheduledates.day)}</h3>
                                                <div className='schedule_scheduleelement_list'>
                                                    {scheduledates.schedules.map(function (scheduleelement) {
                                                        return (
                                                            <div className='schedule_scheduleelement'>
                                                                <h4><FontAwesomeIcon icon={faClock} /> {scheduleelement.startTime} - {scheduleelement.endTime} <br className='m_break' />→ {scheduleelement.title}</h4>
                                                                <p className='schedule_scheduleelement_desc'><FontAwesomeIcon icon={faLocationDot} /> {scheduleelement.location}<br />{scheduleelement.description}</p>
                                                                <div className='schedule_dutys_list'>
                                                                    {scheduleelement.dutys.map(function (dutyelement) {
                                                                        scheduleFormData = { ...scheduleFormData, [dutyelement.dutyId]: (scheduleFormData[dutyelement.dutyId]) ? ((dutyelement.isFull == 1) ? 2 : 1) : 0 };
                                                                        return (
                                                                            <ScheduleDutyCard title={dutyelement.title} waitlistEnabled={eventData.eventWaitlistEnabled} description={dutyelement.description} isFull={dutyelement.isFull} editable={false} value={(scheduleFormData[dutyelement.dutyId]) ? 1 : 0} onclick={() => { console.log(scheduleFormData); setScheduleFormData({ ...scheduleFormData, [dutyelement.dutyId]: (scheduleFormData[dutyelement.dutyId] == 0) ? ((dutyelement.isFull == 1) ? (eventData.eventWaitlistEnabled == 1) ? 2 : 0 : 1) : 0 }); console.log(scheduleFormData) }
                                                                            } />
                                                                        );
                                                                    })}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>

                                <p className='schedule_info'>
                                    Wichtig: Dies ist eine Vorauswahl. Die Veranstalter ändern ggf. die Dienste in Absprache mit dir nochmal ab.<br />
                                    Du kannst deine Angaben zur besseren Planbarkeit nach dem Abschicken nicht nochmal abändern. Für Fragen und Änderungen kontaktierst du bitte den Veranstalter.
                                </p>

                                <CTAButton variant="secondary" className="schedule_send_btn" id="scheduleregistersubmitbtn" hideArrow={false} title={'Absenden'} onclick={() => { postDutySelection() }}></CTAButton>
                                <div align="center">
                                    <p className="responseInfo" id="responseInfo_loading">
                                        Lädt... Bitte warten...
                                    </p>
                                    <p className="responseInfo" id="responseInfo_already">
                                        Du hast bereits deine Wunschdienste hinterlegt. Zum Ändern bitte den Veranstalter kontaktieren.<br />
                                        Fehler: {resError}
                                    </p>
                                    <p className="responseInfo" id="responseInfo_wronginput">
                                        Bitte überprüfe deine Eingaben!<br />
                                        Fehler: {resError}
                                    </p>
                                    <p className="responseInfo" id="responseInfo_servererror">
                                        Es gab einen Fehler bei der Verarbeitung.<br />
                                        Fehler: {resError}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </section>

                <section className='container section' style={{ paddingTop: '8px' }}>

                    <motion.div variants={boxvar2_1} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}>

                        <div className='card info-card'>
                            <div className='eventinfo_box'>
                                <h2>{eventData.eventInfo.box3Header}</h2>
                                <div className="kv-list">
                                    <div className="kv"><FontAwesomeIcon icon={faCalendarPlus} /><b>Anmeldezeitraum</b> {formatDateWithTime(new Date(eventData.eventDates.applicationStart)) + " - " + formatDateWithTime(new Date(eventData.eventDates.applicationEnd))}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faCalendarDays} /><b>Veranstaltung</b> {formatDateWithTime(new Date(eventData.eventDates.dateStart)) + " - " + formatDateWithTime(new Date(eventData.eventDates.dateEnd))}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faChampagneGlasses} /><b>Inhalte</b> {eventData.eventInfo.box3Contents}</div>
                                    <div className="kv"><FontAwesomeIcon icon={faUsers} /><b>Benötigte Helfer</b> {eventData.eventInfo.box3LookingFor}</div>
                                </div>
                                <p>{eventData.eventInfo.box3Text}</p>
                                <div className="contact-list">
                                    {(eventData.eventContactMail != "") ? <a href={"mailto:" + eventData.eventContactMail}><FontAwesomeIcon icon={faEnvelope} /> {eventData.eventContactMail}</a> : null}
                                    {(eventData.eventContactTel != "") ? <a href={"tel:" + eventData.eventContactTel}><FontAwesomeIcon icon={faPhone} /> {eventData.eventContactTel}</a> : null}
                                    <a href={eventData.eventURL} target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faGlobe} /> Webseite des Veranstalters</a>
                                    <a href={eventData.eventImprintURL} target='_blank' rel='noopener noreferrer'><FontAwesomeIcon icon={faScaleBalanced} /> Impressum des Veranstalters</a>
                                    <a><FontAwesomeIcon icon={faBuilding} /> Veranstalter: {eventData.eventOrganizator}</a>
                                    {(eventData.eventOrgId) ? <a href={'/events/public/' + eventData.eventOrgId} className="eventinfo_link_eventlist" onClick={(e) => { e.preventDefault(); lP('/events/public/' + eventData.eventOrgId); }}><FontAwesomeIcon icon={faList} /> Weitere öffentliche Events dieser Organisation</a> : null}
                                </div>
                                <CTAButton variant="secondary" size="sm" hideArrow={true} title={eventData.eventInfo.box3CtaText} onclick={() => oP(eventData.eventContactURL)}></CTAButton>
                                <br /><br /><br />
                            </div>
                        </div>
                    </motion.div>

                </section>
            </main>

            < MainFooter useEventStyle={true} />
        </div >
    )
}
